import React, { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Layout } from "antd";
import { DefaultHeader, Sidemenu } from "components";
import { ILayout } from "types";
import "./style.scss";

const { Header, Content } = Layout;

export const DefaultLayout: React.FC<ILayout> = ({ isAuthenticated }) => {
	const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

	if (!isAuthenticated) {
		return (
			<Navigate
				to="/login"
				state={{ isAuthenticated, error: "user isn't authenticated" }}
			/>
		);
	}
	return (
		<Layout>
			<Sidemenu isCollapsed={isCollapsed} />
			<Layout>
				<div className="content">
					<Header style={{ height: "fit-content", padding: "0" }}>
						<DefaultHeader
							setIsCollapsed={setIsCollapsed}
							isCollapsed={isCollapsed}
						/>
					</Header>

					<Content style={{ height: isCollapsed ? "100vh" : "" }}>
						<Outlet />
					</Content>
				</div>
			</Layout>
		</Layout>
	);
};
